/** sessionStorage flag so a stale chunk triggers at most one automatic reload. */
export const RELOAD_FLAG = 'mgs-chunk-reload'

/** A lazy chunk from an older deploy is gone: a reload fetches the new build. */
export function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? `${error.name} ${error.message}` : String(error ?? '')
  return /dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk .* failed|error loading dynamically/i.test(
    msg,
  )
}

/** Called a few seconds after a healthy boot so the next stale chunk may auto reload again. */
export function clearChunkReloadFlag(): void {
  try {
    sessionStorage.removeItem(RELOAD_FLAG)
  } catch {
    /* storage blocked */
  }
}

/** Full page reload (one place, so tests can watch it). */
export function reloadPage(): void {
  window.location.reload()
}
